import React, { useState, useEffect } from "react";
import { Route , Switch } from "react-router-dom";
import { Toaster , toast } from "react-hot-toast"
import ProtectedRoute from "./components/common/protectedRoute";
import './App.css';

import logger from "./services/logger";
import ReactGA from "react-ga4" ;
import { Analytics } from "@vercel/analytics/react";
import NotFoundPage from "./components/common/notfound";

// GA4Pro
import LandingPage from "./components/landing/page" ;
import LoginPage from "./components/auth/login" ;
import SignupPage from "./components/auth/signup" ;
import Home from "./components/platform/home" ;

import OrganizationPlatformPage from "./components/platform/orgPlatformPage" ;
import GA4ThreadsApp from "./components/platform/agent/GA4ThreadsApp" ;
import PivotPage from "./components/platform/pivot/Pivot" ;
import AlertsPage from "./components/platform/alerts/Alerts" ;
import AccountPage from "./components/platform/account/Account" ;
import PromptLibrary from "./components/platform/agent/PromptLibrary" ;
import AnalystPage from "./components/platform/analyst/AnalystPage" ;
import AnalystFullscreen from "./components/platform/analyst/AnalystFullscreen" ;
import PrivacyPolicy from "./components/common/PrivacyPolicy" ;
import Terms from "./components/common/Terms" ;

const App = () => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    
    if (process.env.REACT_APP_ENVIRON === "production") {
      logger.init();
      ReactGA.initialize('G-3KC33TK96R');
      // console.log('GA4 initialized');
      // Use event() instead of send() for GA4
      ReactGA.event('page_view', {
        page_path: window.location.pathname,
        page_title: document.title
      });
    }
    
  }, []);


  return (
    <>
        <Analytics />
        <Toaster position="top-center"  reverseOrder={false} /> 
        <Switch>

          {/* Organization routes with context */}
          <ProtectedRoute 
            path="/organization/:organizationId/threads" 
            component={GA4ThreadsApp} 
          />
          <ProtectedRoute 
            path="/organization/:organizationId/pivot" 
            component={PivotPage} 
          />
          <ProtectedRoute 
            path="/organization/:organizationId/analyst/fullscreen" 
            component={AnalystFullscreen} 
          />
          <ProtectedRoute 
            path="/organization/:organizationId/analyst" 
            component={AnalystPage} 
          />
          <ProtectedRoute 
            path="/organization/:organizationId/alerts" 
            component={AlertsPage} 
          />
          <ProtectedRoute 
            path="/organization/:organizationId/settings" 
            component={AccountPage} 
          />
          <ProtectedRoute 
            path="/organization/:organizationId" 
            component={OrganizationPlatformPage} 
          />

          <ProtectedRoute path="/home" component={Home} />
          <Route path="/prompt-library" component={PromptLibrary} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/terms-of-service" component={Terms} />
          <Route path="/login" component={LoginPage} />
          <Route path="/signup" component={SignupPage} />
          <Route path="/404" component={NotFoundPage} />
          <Route path="/" component={LandingPage} />

        </Switch>


    </>
  );
}

export default App;